// PRODUCTION CHECK
export const isProd = process.env.NODE_ENV === 'production' ? true : false;

// SESSION EXPIRY TIME (IDE)
export const EXP = isProd ? 1 : 8;
